
export default function Introduction()
{
    return (
        <div className='Page'>
            <h1>Introduction</h1>
            <p>
                Les premiers cours de ce site vont malheureusement devoir être assez rébarbatifs.<br/>
                Bien que j'aime que les choses se fassent petit à petit, il est parfois nécessaire de passer par une partie théorie plus ou moins longue.<br/>
                C'est le cas pour le VG5000 ou un minimum de connaissances de base sont nécessaires.
            </p>
            <p>
                En premier lieu, parlons de la structure même de la machine.
            </p>
            
            <h2>Le fonctionnement</h2>

            <p>
                Architecturé autour d'un processeur Z80 de Zilog, le VG5000 est énormément dépendant de son VDP (Vidéo Display Processor), l'EF9345.<br/>
                Nous avons donc d'un coté la RAM lue par le Z80, mais d'un autre coté une RAM interne au VDP.<br/>
                C'est sur cette seconde RAM que se feront toutes les opérations de modification afin d'afficher quelque chose à l'écran.<br/>
                Le Z80 lui sera occupé à lire votre code mais ne pourra rien afficher.
            </p>

            <p>
                Malheureusement pour nous le VDP est affreusement lent et n'est accessible que par adressage de ses ports via des OUT (instructions pas franchement les plus rapides).<br/>
                Malheureusement encore, il faudra souvent effectuer une dizaine de OUT afin d'envoyer une commande au VDP avec des paramètres, réduisant ainsi comme peau de chagrin votre 
                temps machine qui sera alors et ensuite amputé du temps de réponse du VDP.
            </p>

            <p>
                Le rêve d'avoir un mode texte rapide couplé au Z80 n'aura donc pas lieu sur cette machine.<br/>
                C'est bien dommage car il aurait suffit d'utiliser la RAM centrale comme ram du VDP pour pouvoir l'adresser beaucoup plus rapidement...
            </p>

            <p>
                Nous disposerons d'un port pour lire le clavier directement en revanche ce qui est une bonne nouvelle.
            </p>
            <p>
                En revanche niveau son, seul un bipper est disponible de base, ce qui vous coutera tout votre cpu si vous décidez de faire de la musique par ce biais.<br/>
                Heureusement pour nous des extensions à base de AY-3-8910 pallieront à ce problème.<br/>
                Malheureusement cependant aucun émulateur à l'heure ou je vous parle n'émule ces extensions.
            </p>
            <p>
                Enfin, la machine dispose d'un port de lecture et écriture vers un lecteur K7.
            </p>
            <p>
                Notez que l'extension RAM 5216 vous permet d'avoir un port cartouche.<br/>
                Cette extension n'étant pas toujours facile à trouver, il est cependant possible de se fabriquer un port cartouche.
            </p>

            <h2>Les cours</h2>

            <p>
                Comme sur mes autres sites et comme toujours, ces cours seront didactiques.<br/>
                Nous apprendrons petit à petit avec des exemples simples non optimisés afin que tous même débutants puissent comprendre.
            </p>
            <p>
                Comme la machine est plus ou moins dépourvue de capacités hardware, ces cours seront très orientés vers la programmation du VDP puisque sans lui rien ne se passe.<br/>
                Cette partie sera la plus longue et sans doute la plus pénible, raison pour laquelle j'essayerai si possible de faire des articles court.
            </p>
            <p>
                Enfin, la section documentation vous permettra de trouver des informations complémentaires ou de revenir rapidement sur vos acquis.
            </p>


        </div>
    )
}